import { render, staticRenderFns } from "./PlanSwitchHistory.vue?vue&type=template&id=ffa1807a&scoped=true&"
import script from "./PlanSwitchHistory.vue?vue&type=script&lang=js&"
export * from "./PlanSwitchHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa1807a",
  null
  
)

export default component.exports